<app-loading-spinner *ngIf="isLoading" />

<div *ngIf="!isLoading" class="w-full px-10 py-7 bg-tileLight dark:bg-[#363636] min-h-screen shadow-lg rounded-lg">
    <div class="flex flex-col items-center justify-center my-4">
        <p class="text-lg text-black dark:text-white font-bold my-2">EMP ID : {{targetObj.empId}}</p>
    </div>
    <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4 mt-5">
        <div>
            <label for="varietyNameEnglish" class="block text-sm font-medium text-gray-700 dark:text-textDark">Variety
                Name :</label>
            <input id="varietyNameEnglish" [value]="targetObj.varietyNameEnglish" disabled
                class="mt-1 block w-full p-2 border border-gray-300 rounded-md text-textLight dark:text-textDark bg-tileLight dark:bg-[#1D1D1F]" />
        </div>

        <div>
            <label for="todo" class="block text-sm font-medium text-gray-700 dark:text-textDark">The Maximum Amount You
                Can Pass (kg) :</label>
            <input id="todo" [value]="targetObj.todo" disabled
                class="mt-1 block w-full p-2 border border-gray-300 rounded-md text-textLight dark:text-textDark bg-tileLight dark:bg-[#1D1D1F]" />
        </div>
    </div>

    <hr class="border-b-1 border-[#BDBDBD] my-5" />

    <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4 mt-5">
        <div>
            <label for="variety" class="block text-sm font-medium text-gray-700 dark:text-textDark my-1">
                Select Short Stock Assignee :
            </label>
            <app-searchable-dropdown [items]="officerDropdownItems" placeholder="--Select Officer--"
                searchPlaceholder="Search Officers..." [(ngModel)]="selectedOfficerId"
                (selectionChange)="onOfficerSelectionChange($event)" [clearable]="true" [showSelected]="true"
                [disabled]="false" class="block w-full mb-4"
                borderClass="border-gray-300 border-[1px]">
            </app-searchable-dropdown>

        </div>


        <div>
            <label for="passAmount" class="block text-sm font-medium text-gray-700 dark:text-textDark">The Amount (kg)
                :</label>
            <input #passAmountRef="ngModel" id="passAmount" name="passAmount" type="number" [(ngModel)]="passAmount"
                min="0.001" step="any" (keydown)="preventZeroAndNegative($event)" (input)="validatePassAmount()"
                (blur)="onBlurPassAmount()"
                class="mt-2 block w-full p-2 border border-gray-300 rounded-md text-textLight dark:text-textDark bg-tileLight dark:bg-[#1D1D1F] quantity-input" />
            <div *ngIf="passAmountRef.invalid && passAmountRef.touched" class="text-red-500 text-sm mt-1">
                <span *ngIf="passAmountRef.errors?.['required']">
                    Amount is required.
                </span>

                <span *ngIf="passAmountRef.errors?.['min'] || passAmount <= 0">
                    Amount must be greater than 0.
                </span>
            </div>
        </div>
    </div>

    <div class="flex flex-row justify-center items-center gap-12 my-10">
        <button class="text-[#6B7D8C] border-[#6B7D8C] border-[1px] rounded-lg shadow-md px-4 py-2"
            (click)="onCancel()">Cancel</button>
        <button class="bg-[#415CFF] text-white rounded-lg shadow-md px-6 py-2" (click)="onSubmit()">Save</button>
    </div>
</div>